var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVireCubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 44,
    viewBox: "0 0 35 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4611 34.6159L10.6813 42.916C10.2319 43.1851 9.64522 43.0533 9.36692 42.6157L0.837273 29.1978C0.56085 28.7602 0.700004 28.1889 1.15131 27.9179L14.9311 19.6179C15.3805 19.3487 15.9672 19.4805 16.2455 19.9181L24.7695 33.336C25.0478 33.7754 24.9068 34.3467 24.4611 34.6159Z",
    fill: "#5800FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1772 12.2202L9.69757 18.5336C9.22558 18.8174 8.60692 18.6746 8.31545 18.215L1.83737 8.01061C1.5459 7.55101 1.69257 6.9486 2.16456 6.66479L12.6386 0.356865C13.1106 0.0730538 13.7292 0.215879 14.0207 0.675469L20.5044 10.8798C20.7959 11.3358 20.6511 11.9363 20.1772 12.2202Z",
    fill: "#52C0DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4212 23.0527L26.4011 27.8848C26.0401 28.1008 25.5662 27.9928 25.3424 27.6412L20.3837 19.8319C20.1619 19.4803 20.2728 19.0189 20.6338 18.801L28.6501 13.9725C29.0112 13.7565 29.485 13.8645 29.7088 14.2161L34.6713 22.0255C34.895 22.3752 34.7841 22.8366 34.4212 23.0527Z",
    fill: "#DA295D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.15 9.60277L25.3997 13.0671C25.1402 13.2227 24.8017 13.144 24.6418 12.8913L21.0859 7.292C20.9261 7.03932 21.007 6.70973 21.2665 6.55409L27.0149 3.0916C27.2744 2.93596 27.6129 3.0147 27.7728 3.26738L31.3305 8.86669C31.4885 9.11755 31.4095 9.44896 31.15 9.60277Z",
    fill: "#FFB801"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVireCubeLogo);
export default __webpack_public_path__ + "static/media/vireCube_logo.e3be70fc7de8cff7672953049d0e6e81.svg";
export { ForwardRef as ReactComponent };